/*
 * @Author: 317473294@qq.com
 * @Date: 2023-10-29 16:48:43
 * @LastEditTime: 2023-11-01 10:20:24
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/utils/golobal.js
 */
import store from "@/store/index.js"
// 深度克隆
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  }

 //把当前路由的按钮权限添加到vuex
export function currentRouterToMeta(to){
    const currentRouteNode = to;  
    const rolePrim=currentRouteNode.meta.roles
    console.log("权限存到什么了",rolePrim)
    store.commit("setUserPrimission", rolePrim)
  }


// WEBPACK FOOTER //
// ./src/utils/golobal.js